import React, { useEffect } from 'react'
import styled from 'styled-components'
import AOS from 'aos'
import 'aos/dist/aos.css'


const About = () => {
  useEffect(() => {
    AOS.init()
  },[])
  return (
    <AboutContainer id='AboutSection' >
      <AboutHeading>Our Story</AboutHeading>
      <AboutStory data-aos="fade-left" data-aos-duration='750' data-aos-delay='0' >At Shri Ram Engineering, our story is one of passion, precision, and purpose. For 50 remarkable years, we've been weaving a tale of innovation, dedication, and unwavering commitment to our clients. Our journey is a testament to the values that guide us every day, as we continue to elevate the field of heat treatment solutions
      <br />Our journey began five decades ago, and we've been fueled by passion ever since. The sight of a perfectly treated component, the satisfaction of a delighted client, and the thrill of breaking new ground in heat treatment — these are the emotions that drive us.
      <br />Precision is not just a value we uphold; it's ingrained in our DNA. From the very beginning, we realized that in the world of heat treatment, there's no room for compromise. Every process, every treatment, every component - it all hinges on precision. It's the reason our clients trust us with their most critical projects.
      <br />Our success is built on trust, and trust is built on integrity. We've always believed that our word is our bond. Our clients know that when they choose Shri Ram Engineering, they're choosing a partner who will always deliver on promises, operate ethically, and communicate openly.
      <br />Join us in this extraordinary journey where passion meets precision, and together, we'll continue to script stories of innovation, trust, and excellence. Because at Shri Ram Engineering, we're not just about heat treatment solutions; we're about making dreams come true, one precise, innovative step at a time.</AboutStory>
    </AboutContainer>
  )
}

export default About

const AboutContainer = styled.div`
  margin: 7.5rem 7.5rem 7.5rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media(max-width: 2400px){
    padding: 3.5rem 0rem;
  }

  @media(max-width: 1050px){
    padding: 0rem;
  }

  @media(max-width: 850px){
    flex-direction: column;
    margin: 5rem;
  }

`

const AboutHeading = styled.h1`
  color: #F2B705;
  font-family: var(--font-primary);
  font-size: 5rem;
  font-weight: 600;
  transform: rotate(90deg);
  flex-shrink: 0;

  @media(max-width: 850px){
    transform: rotate(0deg);
    font-size: 6rem;
    margin-bottom: 2rem;
  }

`

const AboutStory = styled.div`
  color: #000;
  font-family: var(--font-secondary);
  font-size: 1.3rem;
  height: 100%;
  font-weight: 300;


`